import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { httpOk, GET, PUT } from 'helpers/api'

/**
 * Пороги аналитики заведения (analytics_settings). Одна модалка на все разделы.
 *
 * section — ключ раздела на бэке (rfm, frozen_funds), url — адрес сохранения,
 * fields — [{ key, label, hint }]. После сохранения вызывает onSaved — экран перезапрашивает отчёт.
 */
function ThresholdsModal({ show, onClose, onSaved, title, section, url, fields }) {
	const [values, setValues] = useState({})
	const [defaults, setDefaults] = useState({})

	useEffect(() => {
		if (!show) return
		GET('/analytics/settings').then(response => {
			if (!httpOk(response)) return
			setValues(response.data.settings?.[section] || {})
			setDefaults(response.data.defaults?.[section] || {})
		})
	}, [show, section])

	async function save(e) {
		e.preventDefault()
		const response = await PUT(url, values, { loader: true })
		if (httpOk(response)) {
			onClose()
			if (onSaved) onSaved()
		}
	}

	return (
		<Modal show={show} onHide={onClose} backdrop="static" centered>
			<Modal.Header closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<form onSubmit={save}>
				<Modal.Body>
					<div className="text-muted mb-3" style={{ fontSize: '13px' }}>
						Пороги действуют для всего заведения и всех, кто смотрит этот отчёт.
					</div>
					{fields.map(field => (
						<div className="form-group mb-3" key={field.key}>
							<label className="mb-1" style={{ fontWeight: 600 }}>{field.label}</label>
							<input
								type="number"
								className="form-control"
								min="1"
								value={values[field.key] ?? ''}
								onChange={(e) => setValues({ ...values, [field.key]: e.target.value === '' ? '' : Number(e.target.value) })}
								required
							/>
							<div className="text-muted" style={{ fontSize: '12px' }}>
								{field.hint}{defaults[field.key] !== undefined && ` По умолчанию: ${defaults[field.key]}.`}
							</div>
						</div>
					))}
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-outline-secondary me-auto" onClick={() => setValues(defaults)}>
						По умолчанию
					</button>
					<button type="button" className="btn btn-outline-secondary" onClick={onClose}>Отмена</button>
					<button type="submit" className="btn btn-primary">Сохранить</button>
				</Modal.Footer>
			</form>
		</Modal>
	)
}

export default ThresholdsModal
